module.exports = __webpack_public_path__ + "img/Barger.fecdbc3d.jpeg";